package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.button.InputButton
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.util.SelectionModel
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateQuestionModel
import com.wintermar.inspection.feature.presentation.inspection.answer.widget.choice_answer.ChoiceAnswer
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_calendar

@Composable
fun InputQuestion(
    question: InspectionTemplateQuestionModel,
    vessels: List<SelectionModel>,
    onClick: (String) -> Unit,
    onShowCalendarModal: () -> Unit,
    onShowLocationModal: () -> Unit,
    onClickVessel: (SelectionModel) -> Unit,
    onValueChanged: (String) -> Unit
) {
    when (question.answerType) {
        InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA,
        InspectionAnswerType.YES_NO_NA,
            -> ChoiceAnswer(question = question, onClick = onClick)

        InspectionAnswerType.VESSEL_ID -> VesselAnswer(
            value = question.answer.answerSelection.answerSelectionValue,
            references = vessels,
            onClick = { selectionModel ->
                if (selectionModel.id == question.answer.answerSelection.answerSelectionId) return@VesselAnswer

                onClickVessel(selectionModel)
            }
        )

        InspectionAnswerType.CALENDAR -> InputButton(
            text = DateTimeUtil.getLocalSystemDisplayWithTime(question.answer.answerDateIso),
            placeholder = "Select date and time",
            leadingIcon = Res.drawable.ic_calendar,
            modifier = Modifier.fillMaxWidth(),
            onClick = onShowCalendarModal
        )

        InspectionAnswerType.ADDRESS -> InputButton(
            text = question.answer.answerLocation.name,
            placeholder = "Select location",
            modifier = Modifier.fillMaxWidth(),
            onClick = onShowLocationModal
        )

        InspectionAnswerType.FREE_TEXT -> InputFreeText(
            answer = question.answer.answerText,
            onValueChanged = { value ->
                if (value == question.answer.answerText) return@InputFreeText

                onValueChanged(value)
            }
        )

        InspectionAnswerType.USER_ID -> InputButton(
            text = question.answer.answerSelection.answerSelectionValue,
            disabled = true, //question.disabled, //TODO: will check with disabled flag
            modifier = Modifier.fillMaxWidth(),
            onClick = {}
        )

        else -> Spacer(modifier = Modifier.fillMaxWidth())
    }
}
